import React from "react";

import PageBanner from "../components/common/PageBanner";
import Gallery from "../components/HomePageComponents/Gallery";

import galleryBanner from "../assets/services-banner.jpg";

const GalleryPage = () => {
  return (
    <>
      <PageBanner title="Our Gallery" bgImage={galleryBanner} />
      <Gallery />
    </>
  );
};

export default GalleryPage;
